import { SidebarToggle } from '@/components/layout/SidebarToggle';
import { AppBreadcrumb } from '@/components/navigation/AppBreadcrumb';
import { FavoritesMenu } from '@/components/navigation/FavoritesMenu';
import { LanguageSwitcher } from '@/components/navigation/LanguageSwitcher';
import { Separator } from '@/components/ui/separator';
import { useAuthContext } from '@/data/hooks/auth';
import useFavoritesStore from '@/data/stores/favorites.store';

/** En-tête de l'application : bascule du menu, fil d'Ariane, favoris et langue. */
export const AppHeader = () => {
  const { isAuthenticated } = useAuthContext();
  const favorites = useFavoritesStore((state) => state.favorites);
  const showFavorites = isAuthenticated && favorites.length > 0;

  return (
    <header className='flex shrink-0 items-center gap-2 border-b bg-card px-4 py-3'>
      <SidebarToggle className='-ml-1' />
      <Separator orientation='vertical' className='mr-2 data-[orientation=vertical]:h-4' />
      <AppBreadcrumb />
      <div className='ml-auto flex items-center gap-2'>
        {showFavorites ? <FavoritesMenu /> : null}
        <LanguageSwitcher />
      </div>
    </header>
  );
};
